<snag-layout
  *ngIf="isBrowser"
  [configuration]="menu"
  [hideLayout]="hideLayout()"
  role="none"
  [enableTopNav]="enableTopNav">
  <router-outlet role="none"></router-outlet>
</snag-layout>
